var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-select',_vm._g(_vm._b({attrs:{"options":_vm.listOptions,"filter-option":_vm.filterOption,"placeholder":"placeholder"}},'a-select',_vm.$props,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }